











































































































import {
	defineComponent,
	PropType,
	computed,
	toRefs,
} from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { EventV2 } from '@front-app/services/EventsApi/EventModel';
import { BannerLocation } from '@front-app/services/ActionApi/UserActionRequestModel';
import { STATUS } from '@front-app/constants/state';
import { useEventRole } from '@front-app/hooks/useMembershipRole';
import { isPastEvent } from '@front-app/views/home/events/filters';
import { Size } from '@front-app/components/constants';
import { Routes } from '@front-app/constants/routes';
import { eventLink } from '@front-app/util/links';
import { useEventBanner } from '@front-app/modules/event/hooks/useEventBanner';
import TrCheckbox from '@front-app/components/inputs/Checkbox.vue';
import RoleBadge from './RoleBadge.vue';

export default defineComponent({
	components: {
		TrCheckbox,
		RoleBadge,
		FontAwesomeIcon,
	},
	props: {
		groupId: {
			type: String,
			default: '',
		},
		event: {
			type: Object as PropType<EventV2>,
			required: true,
		},
		size: {
			type: String as PropType<Size>,
			default: Size.LARGE,
		},
		bannerLocation: {
			type: String as PropType<BannerLocation>,
			required: true,
		},
		showCheckboxes: Boolean,
		isChecked: Boolean,
		isButton: Boolean,
		disableTracking: Boolean,
	},
	setup(props, ctx) {
		const eventBannerData = computed(() => ({
			eventId: props.event.id,
			location: props.bannerLocation,
			groupId: props.groupId,
			disableTracking: props.disableTracking,
		}));
		const {
			banner,
			bannerWrapper,
			onClick,
		} = useEventBanner(eventBannerData);
		const eventUrl = computed(() => eventLink(props.event.id));
		const eventTags = computed(() => props.event.categories
			.concat(props.event.eventTypes.map((t) => ctx.root.$t(t)) as string[])
			.join(', '));
		const isPast = computed(() => isPastEvent(props.event));
		const startDate = computed(() => ctx.root.$d(props.event.startDate, 'long'));

		const eventLinkTo = computed(() => {
			if (props.groupId) {
				return { name: Routes.GROUP_EVENT, params: { eventId: props.event.id } };
			}
			return { name: Routes.EVENT, params: { eventId: props.event.id } };
		});
		return {
			onClick,
			bannerWrapper,
			eventLinkTo,
			startDate,
			isPast,
			eventTags,
			eventRole: useEventRole(toRefs(props).event),
			eventUrl,
			banner,
			Size,
			isLoading: computed(() => banner.value.status === STATUS.LOADING),
		};
	},
});
